import { createListenerMiddleware } from "@reduxjs/toolkit";
import * as selectors from "./selectors";
import { actions } from "./store";

export const listenerMiddleware = createListenerMiddleware();

listenerMiddleware.startListening({
  actionCreator: actions.setCurrentMission,
  effect: (action, api) => {
    // reset project filter and trigger projects refetch
    api.dispatch(
      actions.setProjectFilter({
        search: "",
        order: null,
        status: "all",
        range: null,
      })
    );
  },
});

listenerMiddleware.startListening({
  actionCreator: actions.setProjectPage,
  effect: (action, api) => {
    const currentMission = selectors.selectCurrentMission(api.getState());

    if (!currentMission) return;

    const { review_status } = currentMission;

    // do not refetch projects if user be disabled or mission is not started
    if (
      review_status.status === "disabled" ||
      review_status.status === "not-started"
    ) {
      api.dispatch(actions.clearProjects());
      return;
    }

    api.dispatch(
      actions.fetchProjectsWithFilter({
        page: action.payload,
        subcategory: selectors.selectCurrentMission(api.getState()).subcategory
          .shortcut,
        stage: parseInt(
          currentMission.stage.slice(-1),
          10
        ),
        filter: selectors.selectProjectFilter(api.getState()),
      })
    );
  },
});

listenerMiddleware.startListening({
  actionCreator: actions.refetchProjects,
  effect: (action, api) => {
    const currentMission = selectors.selectCurrentMission(api.getState());

    if (!currentMission) return;

    const { review_status } = currentMission;

    // do not refetch projects if user be disabled or mission is not started
    if (
      review_status.status === "disabled" ||
      review_status.status === "not-started"
    ) {
      api.dispatch(actions.clearProjects());
      return;
    }
    api.dispatch(
      actions.fetchProjectsWithFilter({
        page: selectors.selectProjectPaging(api.getState()).current_page,
        subcategory: selectors.selectCurrentMission(api.getState()).subcategory
          .shortcut,
        stage: parseInt(
          currentMission.stage.slice(-1),
          10
        ),
        filter: selectors.selectProjectFilter(api.getState()),
      })
    );
  },
});

listenerMiddleware.startListening({
  actionCreator: actions.setProjectFilter,
  effect: async (action, api) => {
    const currentMission = selectors.selectCurrentMission(api.getState());

    if (!currentMission) return;

    const { subcategory, review_status } = currentMission;

    // cancel previous delayed effect
    api.cancelActiveListeners();

    // do not refetch projects if user be disabled or mission is not started
    if (
      review_status.status === "disabled" ||
      review_status.status === "not-started"
    ) {
      api.dispatch(actions.clearProjects());
      return;
    }

    await api.delay(500);

    // refetch projects with filter after 500ms debounce
    api.dispatch(
      actions.fetchProjectsWithFilter({
        subcategory: subcategory.shortcut,
        stage: parseInt(currentMission.stage.slice(-1), 10),
        filter: action.payload,
      })
    );
  },
});
